import { render, staticRenderFns } from "./DeleteSurveyPopup.vue?vue&type=template&id=8672b3da&scoped=true&"
import script from "./DeleteSurveyPopup.vue?vue&type=script&lang=ts&"
export * from "./DeleteSurveyPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteSurveyPopup.vue?vue&type=style&index=0&id=8672b3da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8672b3da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8672b3da')) {
      api.createRecord('8672b3da', component.options)
    } else {
      api.reload('8672b3da', component.options)
    }
    module.hot.accept("./DeleteSurveyPopup.vue?vue&type=template&id=8672b3da&scoped=true&", function () {
      api.rerender('8672b3da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/DeleteSurveyPopup.vue"
export default component.exports